import * as Yup from "yup";

export const FIELD_ENUM = {
  pin: "pin",
};

export const validation = {
  [FIELD_ENUM.pin]: Yup.string().trim().required("error_code_match"),
};
